/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Corrections_List_LabelInputs */



/**
* | output |
* | --- |
* | "List of spelling corrections" |
*
* @param {Spellcheck_Corrections_List_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_corrections_list_label = /** @type {((inputs?: Spellcheck_Corrections_List_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Corrections_List_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liste des corrections orthographiques")
	if (locale === "de") return /** @type {LocalizedString} */ ("Liste der Rechtschreibkorrekturen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elenco delle correzioni ortografiche")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Список орфографических исправлений")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lista de correcciones ortográficas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("拼写错误更正列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スペル修正リスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तनी सुधारों की सूची")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lista de correções ortográficas")
	return /** @type {LocalizedString} */ ("List of spelling corrections")
});